import { Injectable } from '@angular/core';
import { UserProfileModel } from '../../entities/user-profile/model/user-profile.model';
import { LoginPageDetails } from './login.model';

@Injectable()
export class LoginContext {
    model: UserProfileModel;
    pageDetails: LoginPageDetails;
    recentlyLogin = false;
}
